import { readRemainingh4lyqt5j6r85 as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readRemaining(_this__u8e3s4.get_response_xlk07e_k$().get_rawContent_u3f8li_k$(), $completion));
  return SavedHttpCall().new_io_ktor_client_call_SavedHttpCall_oecxwk_k$(_this__u8e3s4.client_1, _this__u8e3s4.get_request_jdwg4m_k$(), _this__u8e3s4.get_response_xlk07e_k$(), responseBody);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, request, response, responseBody) {
        return new.target.new_io_ktor_client_call_SavedHttpCall_oecxwk_k$(client, request, response, responseBody);
      }
      static new_io_ktor_client_call_SavedHttpCall_oecxwk_k$(client, request, response, responseBody) {
        var $this = this.new_io_ktor_client_call_HttpClientCall_o2h3p8_k$(client);
        $this.responseBody_1 = responseBody;
        $this.request_1 = new (SavedHttpRequest())($this, request);
        $this.response_1 = new (SavedHttpResponse())($this, $this.responseBody_1, response);
        checkContentLength(contentLength(response), fromInt($this.responseBody_1.length), request.get_method_gl8esq_k$());
        $this.allowDoubleReceive_2 = true;
        return $this;
      }
      get_allowDoubleReceive_um1gnm_k$() {
        return this.allowDoubleReceive_2;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.$$delegate_0__1 = origin;
        this.call_1 = call;
      }
      get_call_wojxrb_k$() {
        return this.call_1;
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
      get_method_gl8esq_k$() {
        return this.$$delegate_0__1.get_method_gl8esq_k$();
      }
      get_url_18iuii_k$() {
        return this.$$delegate_0__1.get_url_18iuii_k$();
      }
      get_attributes_dgqof4_k$() {
        return this.$$delegate_0__1.get_attributes_dgqof4_k$();
      }
      get_content_h02jrk_k$() {
        return this.$$delegate_0__1.get_content_h02jrk_k$();
      }
      get_headers_ef25jx_k$() {
        return this.$$delegate_0__1.get_headers_ef25jx_k$();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.call_1 = call;
        this.body_1 = body;
        this.status_1 = origin.get_status_jnf6d7_k$();
        this.version_1 = origin.get_version_72w4j3_k$();
        this.requestTime_1 = origin.get_requestTime_wwxhg3_k$();
        this.responseTime_1 = origin.get_responseTime_scfvg7_k$();
        this.headers_1 = origin.get_headers_ef25jx_k$();
        this.coroutineContext_1 = origin.get_coroutineContext_115oqo_k$();
      }
      get_call_wojxrb_k$() {
        return this.call_1;
      }
      get_status_jnf6d7_k$() {
        return this.status_1;
      }
      get_version_72w4j3_k$() {
        return this.version_1;
      }
      get_requestTime_wwxhg3_k$() {
        return this.requestTime_1;
      }
      get_responseTime_scfvg7_k$() {
        return this.responseTime_1;
      }
      get_headers_ef25jx_k$() {
        return this.headers_1;
      }
      get_coroutineContext_115oqo_k$() {
        return this.coroutineContext_1;
      }
      get_rawContent_u3f8li_k$() {
        return ByteReadChannel(this.body_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save1hc0jjdmqj6mp,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
